export const RedirectBhbusEmail = (): any => {
  window.location.href = 'https://www.instagram.com/bhbusmidia/';
  return null;
};
